export default "__VITE_PUBLIC_ASSET__ef17de0a__"